import { useEffect, useState } from "react";
import postData from "../custom_functions/postData";
import { url } from "../utils/config";
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";
import Select from "../reusable_components/Select";
import fetchData from "../custom_functions/fetchData";
import patchData from "../custom_functions/patchData";
import Button from "../reusable_components/Button";



function AddManual(props) {
        const [formData, setFormData ] = useState({})
        const [ missingFields, setMissingFields ] = useState([]);
        const [ inputErrors, setInputErrors ] = useState([]);
        const [ showInputError, setShowInputError ] = useState(false);
        const [ manual, setManual ] = useState()
        const [ cars, setCars ] = useState([])

        const requiredFields = ['make', 'model', 'year', 'type', 'title'];

        useEffect(() => {getCars()}, [])

        function getMakeList() {
            const make = [];
            cars.forEach(car => {
                if(!make.includes(car.make)){
                    make.push(car.make)
                }
            })
            return make;
        }

        function getModelList() {
            const model = [];
            cars.forEach(car => {
                if(car.make === formData.make) {
                    model.push(car.model)
                }
            })
            return model
        }

        function getYearList() {
            const year = [];
            cars.forEach(car => {
                if(car.make === formData.make && car.model === formData.model) {
                    year.push(car.year)
                }
            })
            return year
        }

        function updateFormData(e) {
            const { name, value } = e.target;
            const data = {...formData};
            data[name] = value;
            setFormData(data);
        }

        async function getCars() {
            await fetchData(url + '/cars', console.log, (data) => setCars(data.data))
        }

        function addManual() {
            console.log(formData);
            if(!manual) {
                return toast.error('Please select a manual', { autoClose: 3000 })
            }
            if(
                formData.make &&
                formData.model &&
                formData.year &&
                formData.title && formData.title.length > 0 &&
                formData.type &&
                manual &&
                !inputErrors.includes('error')
            ) {
                console.log('Validated')
                const formdata = new FormData();
                // formD
                patchData(`${url}/manual`, formData, (error) => {
                    toast.error(error.response.data.message, { autoClose: 3000 })
                }, (data) => {
                    props.setShowForm(false);
                    toast.success(data.message, { autoClose: 3000 })
                })
            } else {
                let fields = Object.keys(formData);
                let miss = [];
                if (fields.length !== requiredFields.length) {
                    requiredFields.forEach(field => {
                        if(!fields.includes(field))  {
                            miss.push(field)
                        }
                    })
                };
                setMissingFields(miss);
                setShowInputError(true)
            }

        }

        return(
            <div className={modalContainer}>
                <div className="bg-white w-2/3 px-8 pt-8 pb-4 rounded-lg">
                    <div className={modalTitle}>ADD MANUAL</div>
                    <div>
                        <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">
                            <label className={label}>Make</label>
                            <div className="col-span-2">
                                <Select 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="make" 
                                    type='text' 
                                    required={true}
                                    value={formData.make}
                                    className={inputStyle}
                                    placeHolder="Make" 
                                    onChange={e => updateFormData(e)}
                                    options={getMakeList()}
                                />
                            </div>
                            <label className={label}>Model</label>
                            <div className="col-span-2">
                                <Select 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="model" 
                                    type='text' 
                                    required={true}
                                    value={formData.model}
                                    className={inputStyle}
                                    placeHolder="Model" 
                                    onChange={e => updateFormData(e)}
                                    options={getModelList()}
                                />
                            </div>
                        </div>
                     
                        <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">
                            <label className={label}>Year</label>
                            <div className="col-span-2">
                                <Select 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="year" 
                                    type='year' 
                                    required={true}
                                    value={formData.year}
                                    className={inputStyle}
                                    placeHolder="Year" 
                                    onChange={e => updateFormData(e)}
                                    options={getYearList()}
                                />
                            </div>
                            <label className={label}>Manual Type</label>
                            <div className="col-span-2">
                                <Select 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="type" 
                                    type='text' 
                                    required={true}
                                    value={formData.type}
                                    className={inputStyle}
                                    placeHolder="Type" 
                                    onChange={e => updateFormData(e)}
                                    options={['User', 'Technician']}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-5  gap-8 py-2">
                            <label className={label}>Manual Title</label>
                            <div className="col-span-4">
                                <Input 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="title" 
                                    type='text' 
                                    required={true}
                                    value={formData.title}
                                    className={inputStyle}
                                    placeHolder="Enter Title" 
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-5  gap-8 py-2">
                            <label className={label}>Select Manual</label>
                            <div className="text-sm text-center p-2 border border-blue-300 rounded-lg text-blue-500 col-span-4">
                                <label htmlFor="manual-pdf" className=" cursor-pointer">Select Manual</label>
                            </div>
                            <input className="hidden" type="file" id='manual-pdf' onChange={e => setManual(e.target.files[0])}/>
                        </div>
                        <div className="flex justify-between py-3 px-16 gap-8">
                            <button onClick={e => props.setShowForm(false)} className={btnCancel}>Cancel</button>
                            <Button clickHandler={e => addManual()} className={btnOne} name={'Submit'} />
                        </div>
                        <div className="text-red-500 font-semibold text-center">
                            {
                                showInputError && 'Please fill all the fields as directed!'
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

export default AddManual;